import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IFiscalSetup } from 'src/app/xena-api';

@Component({
    selector: 'app-fiscal-preview',
    templateUrl: './fiscal-preview.component.html',
    styleUrls: ['./fiscal-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FiscalPreviewComponent {
  @Input() fiscal: IFiscalSetup;
}
